import React from "react";
import AllSite from "../component/sections/site/AllSite";
import AddSite from "../component/sections/site/AddSite";
import middleware from "./middleware/middleware";
import InfoSite from "../component/sections/site/InfoSite";

const sitesRoutes = [
  {
    path: "/site/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllSite />,
        "AllSite"
      );
    },
    exact: true,
  },
  {
    path: "/site/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddSite />,
        "AddSite"
      );
    },
    exact: true,
  },
  {
    path: "/site/info/:sitePublisherID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <InfoSite />,
        "InfoSite"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
